export interface Session {
	id: string;

	[key: string]: unknown; // network specific extra
}

interface Sessions {
	v: 1;
	active: Record<string /*network */, string /* id */>;
	all: Record<string /* network */, Session[]>;
}

/* intentionally deeply reactive! */
let sessions = $state<Sessions>({ v: 1, active: {}, all: {} });

export const getSessions = () => {
	return {
		get all() {
			return sessions.all;
		},

		get active() {
			return sessions.active;
		},

		get isLoggedIn() {
			return Object.values(sessions.active).length;
		},
	};
};

const loadSession = () => {
	const raw = localStorage.getItem("sessions");
	if (!raw) return;
	// oxlint-disable-next-line typescript/no-unsafe-type-assertion
	sessions = JSON.parse(raw) as Sessions;
};

export const newSession = (network: string, session: object) => {
	loadSession();

	const id = crypto.randomUUID();

	if (!(network in sessions.all)) sessions.all[network] = [];
	sessions.all[network]!.push({ id, ...session });

	if (!(network in sessions.active)) sessions.active[network] = id;

	localStorage.setItem("sessions", JSON.stringify(sessions));
};

/* call in just one svelte component */
export const setupSessions = () => {
	$effect(() => {
		localStorage.setItem("sessions", JSON.stringify(sessions));
	});

	loadSession();
};
